import { TIMEOUT_DELAY } from 'constants/general';
import { lazy, ComponentType } from 'react';

const lazyDelayedImport = <T extends ComponentType<object>>(
  factory: () => Promise<{ default: T }>,
  minLoadTime = TIMEOUT_DELAY.DEFAULT
) =>
  lazy(() =>
    Promise.all([
      factory(),
      new Promise((resolve) => setTimeout(resolve, minLoadTime))
    ]).then(([moduleExports]) => moduleExports)
  );

export default lazyDelayedImport;
